import React from 'react';
import { styled as styled2 } from '@compiled/react';
import CheckCircleIcon from '@atlaskit/icon/core/status-success';
import CrossCircleIcon from '@atlaskit/icon/core/cross-circle';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import { ReadViewContainer } from '../../common/ui/styled.tsx';
import messages from './messages.tsx';

const True = () => {
	const { formatMessage } = useIntl();
	return (
		<Container data-testid="servicedesk-insight-attribute-views.ui.boolean.value-true">
			<IconContainer>
				<CheckCircleIcon
					spacing="spacious"
					label={formatMessage(messages.true)}
					color={token('color.icon.success')}
				/>
			</IconContainer>
			{formatMessage(messages.true)}
		</Container>
	);
};

const False = () => {
	const { formatMessage } = useIntl();
	return (
		<Container data-testid="servicedesk-insight-attribute-views.ui.boolean.value-false">
			<IconContainer>
				<CrossCircleIcon
					spacing="spacious"
					label={formatMessage(messages.false)}
					color={token('color.icon.danger')}
				/>
			</IconContainer>
			{formatMessage(messages.false)}
		</Container>
	);
};

const None = () => {
	const { formatMessage } = useIntl();
	return (
		<Container data-testid="servicedesk-insight-attribute-views.ui.boolean.value-none">
			{formatMessage(messages.none)}
		</Container>
	);
};

export const BooleanReadView = ({ value }: { value: boolean | null }): React.JSX.Element => {
	let dropdownChild;
	switch (value) {
		case true:
			dropdownChild = <True />;
			break;
		case false:
			dropdownChild = <False />;
			break;
		case null:
			dropdownChild = <None />;
			break;
		default:
			break;
	}
	return <ReadViewContainer isPlaceholder={value === null}>{dropdownChild}</ReadViewContainer>;
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Container = styled2.div({
	display: 'flex',
	alignItems: 'center',
	flexWrap: 'wrap',
	gap: token('space.100'),
	minHeight: '24px', // To prevent vertical jumping
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const IconContainer = styled2.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'> span': {
		verticalAlign: 'middle',
	},
});
